import { useCallback, useEffect, useState } from "react";
import { errorText } from "./api";

export interface Resource<T> {
  data: T | null;
  error: string | null;
  /** Yeniden yükler; sonuç geldiğinde bileşen yeniden çizilir. */
  reload: () => void;
}

/**
 * Bir ekranın verisini yükler. State yalnızca istek tamamlandığında güncellenir; bileşen kaldırılmışsa veya daha yeni
 * bir yükleme başlamışsa eski sonuç yok sayılır.
 *
 * @param load referansı kararlı olmalı (`useCallback`); değişince yeniden yüklenir
 */
export function useResource<T>(load: () => Promise<T>): Resource<T> {
  const [state, setState] = useState<{ data: T | null; error: string | null }>({ data: null, error: null });
  const [version, setVersion] = useState(0);

  useEffect(() => {
    let current = true;
    load().then(
      (data) => current && setState({ data, error: null }),
      (error: unknown) => current && setState((s) => ({ data: s.data, error: errorText(error) })),
    );
    return () => {
      current = false;
    };
  }, [load, version]);

  const reload = useCallback(() => setVersion((v) => v + 1), []);
  return { ...state, reload };
}
